import { useAppContext } from "@components/AppContext"

const isSponsor = () => {
  const { isBroker } = useAppContext()

  return isBroker
}

export default isSponsor
